import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { normalizeSearchText, matchesSearch } from '../../common/utils/normalize';
export default class EditMatchScorePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "match", null);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "saving", false);
    // Local / Visitor input fields
    _defineProperty(this, "scoreLocal", '');
    _defineProperty(this, "scoreVisitor", '');
    _defineProperty(this, "status", 'scheduled');
    _defineProperty(this, "isKnockout", false);
    _defineProperty(this, "knockoutWinner", '');
    _defineProperty(this, "isLocal", true);
    _defineProperty(this, "goalEvents", []);
    _defineProperty(this, "players", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    const id = m.route.param('id');
    this.loadAllData(id);
  }
  loadAllData(id) {
    this.loading = true;
    m.redraw();
    const pMatch = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(id, "?include=players,discussion,season,preMatchDiscussion,bolillaDiscussion")
    });
    const pPlayers = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players?active=1"
    });
    Promise.all([pMatch, pPlayers]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        matchResponse = _ref2[0],
        playersResponse = _ref2[1];
      app.store.pushPayload(matchResponse);
      this.players = app.store.pushPayload(playersResponse) || [];
      this.match = app.store.getById('nagusi_matches', id);
      if (this.match) {
        this.initForm();
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_not_found'));
        m.route.set(app.route('bizkaitarra-lineup.matches'));
      }
      this.loading = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading score editor data:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_load'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
      this.loading = false;
      m.redraw();
    });
  }
  initForm() {
    if (!this.match) return;
    this.isLocal = !!this.match.isLocal();
    const currentStatus = this.match.attribute('status') || (typeof this.match.status === 'function' ? this.match.status() : null);
    this.status = currentStatus || (this.match.scoreAthletic() !== null ? 'finished' : 'scheduled');
    const scoreAthletic = this.match.scoreAthletic();
    const scoreOpponent = this.match.scoreOpponent();
    if (scoreAthletic !== null && scoreAthletic !== undefined) {
      this.scoreLocal = String(this.isLocal ? scoreAthletic : scoreOpponent);
      this.scoreVisitor = String(this.isLocal ? scoreOpponent : scoreAthletic);
    } else {
      this.scoreLocal = '';
      this.scoreVisitor = '';
    }
    this.isKnockout = !!this.match.isKnockout();
    this.knockoutWinner = this.match.knockoutWinner() || '';
    const rawGoals = this.match.goalEvents();
    this.goalEvents = Array.isArray(rawGoals) ? rawGoals.map(g => ({
      team: g.team || 'local',
      minute: g.minute || '',
      playerId: g.player_id || g.playerId || null,
      name: g.name || '',
      isOwnGoal: !!(g.is_own_goal || g.isOwnGoal),
      showDropdown: false
    })) : [];
  }
  addGoalEvent() {
    this.goalEvents.push({
      team: 'local',
      minute: '',
      playerId: null,
      name: '',
      isOwnGoal: false,
      showDropdown: false
    });
    m.redraw();
  }
  removeGoalEvent(index) {
    this.goalEvents.splice(index, 1);
    m.redraw();
  }
  onScoreInput() {
    const localFilled = this.scoreLocal.trim() !== '';
    const visitorFilled = this.scoreVisitor.trim() !== '';

    // Si se introduce marcador y el estado era programado (o vacío), pasar inmediatamente a 'finished'
    if ((localFilled || visitorFilled) && this.status === 'scheduled') {
      this.status = 'finished';
    } else if (!localFilled && !visitorFilled && this.status === 'finished') {
      // Si se vacían ambos campos y originalmente no tenía resultado guardado, volver a 'scheduled'
      if (this.match && (this.match.scoreAthletic() === null || this.match.scoreAthletic() === undefined)) {
        this.status = 'scheduled';
      }
    }
  }
  getFilteredPlayers(query) {
    if (!query) return [];
    const q = normalizeSearchText(query);
    return this.players.filter(p => {
      if (matchesSearch(p.name(), q)) return true;
      const aliases = (p.attribute('aliases') || '').split(/[;,]/);
      return aliases.some(a => matchesSearch(a, q));
    }).slice(0, 8);
  }
  getScoreMismatchNotice() {
    const localVal = parseInt(this.scoreLocal) || 0;
    const visitorVal = parseInt(this.scoreVisitor) || 0;
    const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
    const rivalObj = this.match ? this.match.rival() : null;
    const opponentName = rivalObj ? rivalObj.name() : this.match ? this.match.opponent() : 'Rival';
    const localName = this.isLocal ? athleticName : opponentName;
    const visitorName = this.isLocal ? opponentName : athleticName;
    let localGoals = 0;
    let visitorGoals = 0;
    this.goalEvents.forEach(g => {
      if (g.team === 'local') localGoals++;else if (g.team === 'visitor') visitorGoals++;
    });
    if (localGoals !== localVal || visitorGoals !== visitorVal) {
      return "Aviso: Goles registrados (".concat(localName, ": ").concat(localGoals, ", ").concat(visitorName, ": ").concat(visitorGoals, ") no coinciden con el marcador (").concat(localVal, " - ").concat(visitorVal, "). Puedes guardar de todas formas.");
    }
    return null;
  }
  saveScore(e) {
    e.preventDefault();
    this.saving = true;
    const scoreLocalVal = this.scoreLocal.trim() !== '' ? parseInt(this.scoreLocal) : null;
    const scoreVisitorVal = this.scoreVisitor.trim() !== '' ? parseInt(this.scoreVisitor) : null;
    const isSuspended = this.status === 'suspended_with_lineup' || this.status === 'suspended_without_lineup';
    let finalStatus = this.status;
    let scoreAthletic = null;
    let scoreOpponent = null;
    let formattedGoalEvents = [];
    if (!isSuspended) {
      scoreAthletic = this.isLocal ? scoreLocalVal : scoreVisitorVal;
      scoreOpponent = this.isLocal ? scoreVisitorVal : scoreLocalVal;
      if (scoreAthletic !== null && scoreOpponent !== null) {
        finalStatus = 'finished';
      }
      formattedGoalEvents = this.goalEvents.map(g => ({
        team: g.team,
        minute: g.minute.trim(),
        player_id: g.playerId ? parseInt(g.playerId) : null,
        name: g.name.trim(),
        is_own_goal: !!g.isOwnGoal
      }));
    }
    const method = 'PATCH';
    const url = app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches/' + this.match.id();
    const attributes = {
      status: finalStatus,
      scoreAthletic,
      scoreOpponent,
      isKnockout: isSuspended ? false : this.isKnockout,
      knockoutWinner: isSuspended ? null : this.isKnockout ? this.knockoutWinner : null,
      goalEvents: formattedGoalEvents
    };
    app.request({
      method,
      url,
      body: {
        data: {
          type: 'nagusi_matches',
          id: this.match.id(),
          attributes
        }
      }
    }).then(res => {
      if (res && res.meta && typeof res.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = res.meta.pendingCount;
      }
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.success_update'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
    }).catch(error => {
      console.error('Error saving score:', error);
      this.saving = false;
      if (error && error.response && error.response.errors) {
        const firstErr = error.response.errors[0];
        if (firstErr && firstErr.detail) {
          app.alerts.show({
            type: 'error'
          }, firstErr.detail);
        } else {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_save'));
        }
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_validation'));
      }
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "EditMatchScorePage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    return m("div", {
      className: "EditMatchScorePage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_matches')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_taldezaina'))), m("div", {
      className: "EditMatch-header",
      style: "margin-bottom: 40px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.edit_score_title')), m("p", {
      style: "color: var(--muted-color); font-size: 1.25em; margin-top: 4px;"
    }, this.match.getName())), m("form", {
      onsubmit: this.saveScore.bind(this)
    }, m("div", {
      style: "max-width: 650px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; color: var(--heading-color);"
    }, m("i", {
      className: "fas fa-futbol",
      style: "margin-right: 8px; color: var(--primary-color);"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.section_score')), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 20px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_score_local')), m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      placeholder: "--",
      value: this.scoreLocal,
      oninput: e => {
        this.scoreLocal = e.target.value;
        this.onScoreInput();
      },
      style: "border-radius: 8px; padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_score_visitor')), m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      placeholder: "--",
      value: this.scoreVisitor,
      oninput: e => {
        this.scoreVisitor = e.target.value;
        this.onScoreInput();
      },
      style: "border-radius: 8px; padding: 10px 14px;"
    }))), m("div", {
      style: "display: flex; align-items: center; gap: 10px; margin-top: 10px; background: rgba(255,255,255,0.01); padding: 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.04);"
    }, m("input", {
      type: "checkbox",
      id: "chkKnockout",
      checked: this.isKnockout,
      onchange: e => {
        this.isKnockout = e.target.checked;
        if (!this.isKnockout) this.knockoutWinner = '';
        m.redraw();
      },
      style: "width: 18px; height: 18px; cursor: pointer;"
    }), m("label", {
      htmlFor: "chkKnockout",
      style: "font-weight: bold; color: var(--heading-color); font-size: 0.95em; cursor: pointer; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_knockout'))), this.isKnockout && m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; animation: fadeIn 0.2s ease-out;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_knockout_winner')), m("select", {
      className: "FormControl",
      value: this.knockoutWinner,
      onchange: e => {
        this.knockoutWinner = e.target.value;
        m.redraw();
      },
      style: "border-radius: 8px; height: 42px;"
    }, m("option", {
      value: ""
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.knockout_winner_placeholder')), m("option", {
      value: "Athletic"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.knockout_winner_athletic')), m("option", {
      value: "Rival"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.knockout_winner_rival')))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; margin-top: 5px; background: rgba(255,255,255,0.02); padding: 14px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("label", {
      style: "font-weight: bold; color: var(--heading-color); font-size: 0.95em; display: flex; align-items: center; gap: 8px; margin: 0;"
    }, m("i", {
      className: "fas fa-info-circle",
      style: "color: var(--muted-color);"
    }), "Estado del partido"), m("select", {
      className: "FormControl",
      value: this.status,
      onchange: e => {
        this.status = e.target.value;
        if (this.status === 'suspended_with_lineup' || this.status === 'suspended_without_lineup') {
          this.scoreLocal = '';
          this.scoreVisitor = '';
          this.goalEvents = [];
        }
        m.redraw();
      },
      style: "border-radius: 8px; height: 42px;"
    }, m("option", {
      value: "finished"
    }, "Normal (Finalizado con resultado)"), m("option", {
      value: "scheduled"
    }, "Programado (Pendiente de disputar)"), m("option", {
      value: "suspended_with_lineup"
    }, "\u26A0\uFE0F Suspendido (11 Aldeanos otorgado)"), m("option", {
      value: "suspended_without_lineup"
    }, "\u26A0\uFE0F Suspendido (sin 11 Aldeanos)")), this.status === 'finished' && m("p", {
      style: "margin: 4px 0 0 0; font-size: 0.85em; color: #10b981; line-height: 1.4;"
    }, m("i", {
      className: "fas fa-check-circle",
      style: "margin-right: 4px;"
    }), "Marcado como finalizado con resultado oficial."), this.status === 'suspended_with_lineup' && m("p", {
      style: "margin: 4px 0 0 0; font-size: 0.85em; color: #f59e0b; line-height: 1.4;"
    }, m("i", {
      className: "fas fa-check-circle",
      style: "margin-right: 4px;"
    }), "Los puntos de 11 Aldeanos se mantendr\xE1n en la clasificaci\xF3n. Las valoraciones y La Bolilla quedar\xE1n anuladas para este encuentro."), this.status === 'suspended_without_lineup' && m("p", {
      style: "margin: 4px 0 0 0; font-size: 0.85em; color: #ef4444; line-height: 1.4;"
    }, m("i", {
      className: "fas fa-times-circle",
      style: "margin-right: 4px;"
    }), "Se anulan valoraciones, La Bolilla y 11 Aldeanos para este encuentro.")), !(this.status === 'suspended_with_lineup' || this.status === 'suspended_without_lineup') && m("div", {
      style: "margin-top: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; display: flex; flex-direction: column; gap: 15px;"
    }, m("div", {
      style: "display: flex; align-items: center; justify-content: space-between;"
    }, m("h3", {
      style: "font-size: 1.15em; font-weight: bold; margin: 0; color: var(--heading-color);"
    }, "\u26BD Goleadores y Minutos"), m(Button, {
      type: "button",
      className: "Button Button--secondary",
      onclick: () => this.addGoalEvent(),
      style: "border-radius: 8px; font-weight: bold; padding: 6px 14px; font-size: 0.85em;"
    }, m("i", {
      className: "fas fa-plus",
      style: "margin-right: 6px;"
    }), " A\xF1adir Gol")), this.getScoreMismatchNotice() && m("div", {
      style: "background: rgba(245,158,11,0.15); border: 1px solid rgba(245,158,11,0.4); color: #fbbf24; border-radius: 8px; padding: 10px 14px; font-size: 0.9em; font-weight: 600; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), m("span", null, this.getScoreMismatchNotice())), this.goalEvents.length === 0 ? m("p", {
      style: "color: var(--muted-color); font-size: 0.9em; margin: 0; font-style: italic;"
    }, "No hay goles registrados todav\xEDa. Haz clic en \"A\xF1adir Gol\".") : m("div", {
      style: "display: flex; flex-direction: column; gap: 12px;"
    }, this.goalEvents.map((item, idx) => {
      const selectedPlayer = item.playerId ? this.players.find(p => String(p.id()) === String(item.playerId)) : null;
      const photo = selectedPlayer && typeof selectedPlayer.photoUrl === 'function' ? selectedPlayer.photoUrl() : null;
      const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
      const rivalObj = this.match ? this.match.rival() : null;
      const opponentName = rivalObj ? rivalObj.name() : this.match ? this.match.opponent() : 'Rival';
      const localName = this.isLocal ? athleticName : opponentName;
      const visitorName = this.isLocal ? opponentName : athleticName;
      return m("div", {
        style: "background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 10px; padding: 12px; display: flex; flex-direction: column; gap: 10px;"
      }, m("div", {
        style: "display: grid; grid-template-columns: 140px 80px 1fr 40px; gap: 10px; align-items: center;"
      }, m("select", {
        className: "FormControl",
        value: item.team,
        onchange: e => {
          item.team = e.target.value;
          m.redraw();
        },
        style: "border-radius: 6px; font-size: 0.85em; padding: 4px 6px; height: 36px;"
      }, m("option", {
        value: "local"
      }, localName), m("option", {
        value: "visitor"
      }, visitorName)), m("input", {
        className: "FormControl",
        placeholder: "Ej: 34'",
        value: item.minute,
        oninput: e => {
          item.minute = e.target.value;
          m.redraw();
        },
        style: "border-radius: 6px; font-size: 0.85em; padding: 4px 8px; height: 36px;"
      }), m("div", {
        style: "position: relative; display: flex; align-items: center; gap: 8px;"
      }, photo && m("img", {
        src: photo,
        alt: "",
        style: "width: 28px; height: 28px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.2); flex-shrink: 0;"
      }), m("input", {
        className: "FormControl",
        placeholder: "Nombre o selecciona de la plantilla...",
        value: item.name,
        oninput: e => {
          item.name = e.target.value;
          item.playerId = null;
          item.showDropdown = true;
          m.redraw();
        },
        onfocus: () => {
          item.showDropdown = true;
          m.redraw();
        },
        style: "border-radius: 6px; font-size: 0.85em; padding: 4px 8px; height: 36px; width: 100%;"
      }), item.showDropdown && item.name.trim().length > 0 && m("div", {
        style: "position: absolute; top: 40px; left: 0; right: 0; background: #1e293b; border: 1px solid rgba(255,255,255,0.15); border-radius: 8px; max-height: 160px; overflow-y: auto; z-index: 100; box-shadow: 0 4px 12px rgba(0,0,0,0.4);"
      }, this.getFilteredPlayers(item.name).map(p => m("div", {
        onclick: () => {
          item.playerId = p.id();
          item.name = p.name();
          item.showDropdown = false;
          m.redraw();
        },
        style: "padding: 8px 12px; cursor: pointer; display: flex; align-items: center; gap: 8px; border-bottom: 1px solid rgba(255,255,255,0.05); transition: background 0.1s ease;",
        onmouseover: e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)',
        onmouseout: e => e.currentTarget.style.background = 'transparent'
      }, p.photoUrl() && m("img", {
        src: p.photoUrl(),
        alt: "",
        style: "width: 22px; height: 22px; border-radius: 50%; object-fit: cover;"
      }), m("span", {
        style: "font-weight: bold; font-size: 0.85em; color: #fff;"
      }, p.name()))), m("div", {
        onclick: () => {
          item.showDropdown = false;
          m.redraw();
        },
        style: "padding: 6px 12px; cursor: pointer; font-size: 0.8em; color: var(--muted-color); text-align: center; background: rgba(0,0,0,0.2);"
      }, "Cerrar sugerencias"))), m(Button, {
        type: "button",
        className: "Button Button--link",
        onclick: () => this.removeGoalEvent(idx),
        style: "color: #ef4444; padding: 4px; border-radius: 6px;"
      }, m("i", {
        className: "fas fa-trash-alt"
      }))), m("div", {
        style: "display: flex; align-items: center; gap: 8px; font-size: 0.8em; color: var(--muted-color); padding-left: 4px;"
      }, m("input", {
        type: "checkbox",
        id: "isOwnGoal_".concat(idx),
        checked: !!item.isOwnGoal,
        onchange: e => {
          item.isOwnGoal = e.target.checked;
          m.redraw();
        },
        style: "cursor: pointer;"
      }), m("label", {
        htmlFor: "isOwnGoal_".concat(idx),
        style: "cursor: pointer; margin: 0;"
      }, "Gol en propia puerta (p.p.)")));
    }))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; margin-top: 15px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button",
      style: "border-radius: 8px; padding: 10px 20px; font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving,
      style: "border-radius: 8px; padding: 10px 24px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-save"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.matches.btn_save_data')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditMatchScorePage', EditMatchScorePage);